import React from "react";
import "../../styles/components/CommunicationCard.scss";
import AddToolTip from "../AddToolTip";
import { get, isEmpty } from "lodash";
import { useHistory } from "react-router";
import { faEnvelope, faSms } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ConfigureCommunicationField from "../ConfigureCommunicationField";
import {
  CategoryEnumOptions,
  CategoryOptions,
  getAdvancedPathWithParam,
  getPathWithParam,
  MANAGE_COMMUNICATION_ROUTES,
} from "../../utils";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
const CommunicationCard = (props) => {
  const {
    labels,
    data,
    eventsList,
    isCommunication,
    isAllEvent,
    isPlanLevelCommunication,
  } = props;
  const history = useHistory();
  const levelOptions = {
    1: "Global",
    2: "Plan Level",
    3: "Plan Group",
  };
  const newCommunication = () => {
    history.push(
      getAdvancedPathWithParam({
        path: MANAGE_COMMUNICATION_ROUTES.COMMUNICATION_INFO,
        // pathParam: [FLOW_TYPES.ADD],
      })
    );
  };
  const eventCategoryBasedOnEventName = (eventName) => {
    var event = eventsList?.find((_) => _?.label == eventName);
    var eventCategory = CategoryOptions?.find(
      (_) => _?.value === event?.eventCategory
    )?.label;
    return eventCategory;
  };

  const planLevelCommunicationLabels = [
    { columnName: "eventOrScheduleName" },
    { columnName: "eventCategory" },
    // { label: "Type", columnName: "eventType" },
    // { label: "Channel", columnName: "channel" },
    {
      columnName: "configuredCommunications",
    },
  ];
  const communicationLabels = [
    { label: "Communication Name", columnName: "communicationDetail" },
    { label: "Event Detail", columnName: "eventDetail" },
    { label: "Level", columnName: "levelDetail" },
    { label: "Layout", columnName: "layoutName" },
    // { label: "Type", columnName: "type" },
  ];
  const ToolData = (x, data, y) => {
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        <FontAwesomeIcon
          icon={icons[x]}
          size="md"
          style={{ paddingRight: "5px" }}
        />
        {y === 1 ? "None" : <AddToolTip name={data} />}
      </div>
    );
  };

  const icons = ["", faEnvelope, faSms];
  const ToolList = (x) => {
    if (x.length === 0) return [1].map((x) => ToolData(x, "", 1));
    else if (x.length === 1)
      return (
        <div>
          {ToolData(
            x[0].channelOfCommunication,
            x[0].communicationNameWithActiveLevel,
            2
          )}
          {/* {ToolData(x[0].channelOfCommunication === 1 ? 2 : 1, "", 1)} */}
        </div>
      );
    return x?.map((_) =>
      ToolData(_.channelOfCommunication, _.communicationNameWithActiveLevel, 2)
    );
  };
  return (
    <>
      {isPlanLevelCommunication ? (
        <div className="communicationCard">
          <div className="labels">
            {planLevelCommunicationLabels.map((item, index) => {
              if (item.columnName === "configuredCommunications")
                return (
                  <div
                    style={{ justifyContent: "center" }}
                    className={`component ${item.columnName}`}
                  >
                    <div className="item">
                      {ToolList(data[item.columnName])}
                    </div>
                  </div>
                );
              if (item.columnName === "eventOrScheduleName")
                return (
                  <div className={`component ${item.columnName}`}>
                    <div className="item">
                      {<AddToolTip displayTooltip={(data[item.columnName].length > 35) ? true : false} name={data[item.columnName]} />}
                    </div>
                  </div>
                );
              if (item.columnName === "eventCategory")
                return (
                  <div className={`component ${item.columnName}`}>
                    <div className="item">
                      {<AddToolTip displayTooltip={(data[item.columnName].length > 35) ? true : false} name={data[item.columnName]} />}
                    </div>
                  </div>
                );
              return (
                <div className={`component ${item.columnName}`}>
                  <div className="label">{item.label}</div>
                  <div className="item">{data[item.columnName]}</div>
                </div>
              );
            })}
          </div>
        </div>
      ) : isAllEvent ? (
        <>
          <div className="communicationCard">
            <div className="labels d-flex p-2 ml-3">
              <div
                className="component"
                style={{ width: "30%", paddingLeft: "20px" }}
              >
                <div className="item">{<AddToolTip name={data.label} />}</div>
              </div>
              <div
                className="component"
                style={{ width: "30%", paddingLeft: "5px" }}
              >
                <div className="item">
                  {
                    <AddToolTip
                      name={eventCategoryBasedOnEventName(data.label)}
                    />
                  }
                </div>
              </div>
              <div className="component" style={{ width: "33%" }}>
                <div className="item" style={{ paddingTop: "5px" }}>
                  <ConfigureCommunicationField
                    data="Configure Communication"
                    width="103%"
                    color="#000000"
                    height="104px"
                    border="2px dashed"
                    padding="20px"
                    backgroundColor="white"
                    onClickNavigate={newCommunication}
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="communicationCard">
          <div className="labels d-flex p-2 ml-3">
            {communicationLabels.map((item, index) => {
              if (item.columnName === "communicationDetail")
                return (
                  <>
                    <div
                      className="component communicationDetail "
                      style={{ width: "36%" }}
                    >
                      <div className="item d-flex align-items-center">
                        <FontAwesomeIcon
                          icon={icons[data.channel]}
                          size="lg"
                          style={{ paddingRight: "5px" }}
                        />
                        <span className="excel-text">
                          {data[item.columnName]?.name.length > 21 ? (
                            <OverlayTrigger
                              placement="top-start"
                              overlay={
                                <Tooltip>{data[item.columnName]?.name}</Tooltip>
                              }
                            >
                              <div className="item font-weight-bold text-dark mb-0">
                                {(data[item.columnName]?.name || "").slice(
                                  0,
                                  21
                                )}
                                ...
                              </div>
                            </OverlayTrigger>
                          ) : (
                            <div className="item font-weight-bold text-dark mb-0">
                              {data[item.columnName]?.name}
                            </div>
                          )}
                        </span>
                      </div>
                      <div className="label" style={{ width: "220px" }}>
                        {data[item.columnName]?.description}
                      </div>
                    </div>
                  </>
                );
              else if (item.columnName === "eventDetail")
                return (
                  <div
                    className="component eventDetail"
                    style={{ width: "39%" }}
                  >
                    <div className="item">
                      <div
                        className="excel-text"
                        style={{ width: "fit-content" }}
                      >
                        {data?.eventName?.length > 25 ? (
                          <AddToolTip name={data?.eventName}>
                            <div className="item text-dark">
                              {(data?.eventName).slice(0, 25)}...
                            </div>
                          </AddToolTip>
                        ) : (
                          <div className="item text-dark">
                            {data?.eventName}
                          </div>
                        )}
                      </div>
                      <div>
                        Category{" "}
                        <span className="text-dark">
                          {" "}
                          {eventCategoryBasedOnEventName(data?.eventName)}
                        </span>
                      </div>
                    </div>
                  </div>
                );
              else if (item.columnName === "levelDetail")
                return (
                  <div
                    className={`component eventDetail`}
                    style={{ width: "25%" }}
                  >
                    <div className="item">
                      <span className="excel-text">
                        {levelOptions[data[item.columnName]?.level]?.length >
                        10 ? (
                          <OverlayTrigger
                            placement="top-start"
                            overlay={
                              <Tooltip>
                                {levelOptions[data[item.columnName]?.level]}
                              </Tooltip>
                            }
                          >
                            <div className="item text-dark">
                              {(
                                levelOptions[data[item.columnName]?.level] || ""
                              ).slice(0, 10)}
                              ...
                            </div>
                          </OverlayTrigger>
                        ) : (
                          <div className="item text-dark">
                            {levelOptions[data[item.columnName]?.level]}
                          </div>
                        )}
                      </span>
                    </div>
                  </div>
                );
              else if (item.columnName === "layoutName")
                return (
                  <div
                    className={`component ${item.columnName}`}
                    style={{ width: "19%" }}
                  >
                    <div className="item">
                      <span className="excel-text">
                        {data[item.columnName].length > 13 ? (
                          <OverlayTrigger
                            placement="top-start"
                            overlay={<Tooltip>{data[item.columnName]}</Tooltip>}
                          >
                            <div className="item text-dark">
                              {(data[item.columnName] || "").slice(0, 13)}...
                            </div>
                          </OverlayTrigger>
                        ) : (
                          <div className="item text-dark">
                            {data[item.columnName]}
                          </div>
                        )}
                      </span>
                    </div>
                  </div>
                );
              return (
                <div className={`component ${item.columnName}`}>
                  <div className="label">{item.label}</div>
                  <div className="item">{data[item.columnName]}</div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default CommunicationCard;
